import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Card } from "../ui/Card";
import { getIconThumbnail, IconData, IconPackData } from "../../data/icons";
import { Button } from "../ui/Button";
import { Label } from "../common/Label";
import { IconPackModal2 } from "../modals/IconPackModal_02";
import { shuffled } from "../../lib/util";

export interface IconPackCardProps {
    packData: IconPackData;
}

const MAX_ICONS_PER_CARD = 8;

export const IconPackCard = (props: IconPackCardProps) => {
    const { packData } = props;

    const iconSubset = shuffled(packData.icons.slice(0, MAX_ICONS_PER_CARD));

    return (
        <Card className="justify-between items-start">
            <div className="flex flex-col w-full justify-between items-start">
                <h3 className="font-heading text-lg font-bold text-surface-100 truncate break-words whitespace-break-spaces">
                    {packData.name}
                </h3>

                <div className="flex items-center gap-2 mt-2">
                    <Label variant="green">{packData.icons.length} icons</Label>
                    <Label variant="new">NEW</Label>
                </div>
            </div>

            <div className="mt-5 grid grid-cols-4 gap-2 flex-grow">
                {iconSubset.map(icon => <IconPackThumbnail
                    key={icon.id}
                    data={icon}
                />)}
            </div>

            <div className="w-full items-end">
                <IconPackModalButton packData={packData} />
                
            </div>
        </Card>
    );
};

export interface IconPackThumbnailProps {
    data: IconData;
}

export const IconPackThumbnail = (props: IconPackThumbnailProps) => {
    const { data } = props;
    return (
        <div className="bg-surface-900 rounded-md flex-center aspect-square w-12 h-12 p-1">
            <img
                alt={data.name}
                src={getIconThumbnail(data.previewImage, 64, 80)}
                className="w-full h-full object-contain object-center"
            />
        </div>
    );
};

export interface IconPackModalButtonProps {
    packData: IconPackData;
}

const IconPackModalButton = (props: IconPackModalButtonProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { packData } = props;

    if (!packData) {
        throw new Error("IconPackModalButton rendering without `iconData`");
    }

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <div className="mt-4">
                <Button
                    intent="ghost"
                    size="medium"
                    className="flex flex-row items-end px-0 py-0 hover:text-brand-500" // don't like py-0 but w/e
                    onClick={openModal}
                >
                    View Pack
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                </Button>
            </div>

            <IconPackModal2
                iconPackData={packData}
                isOpen={isModalOpen}
                onClose={closeModal}
            />
        </>
    );
};





